import React, { PureComponent } from 'react';

import classnames from 'classnames';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';

import Customizer from '../components/@vuexy/customizer/Customizer';
import ComboKeys from '../components/combokeys/ComboKeys';
import {
  changeMode,
  collapseSidebar,
  changeNavbarColor,
  changeNavbarType,
  changeFooterType,
  changeMenuColor,
  hideScrollToTop,
} from '../redux/actions';
import { CustomizerState } from '../redux/customizer/reducer';
import { ThemeStyle } from '../redux/customizer/types';
import { RootState } from '../redux/reducers';
import Footer from './components/footer/Footer';
import Navbar from './components/navbar/Navbar';
import Sidebar from './components/sidebar/Sidebar';

interface IProps extends RouteComponentProps {
  customizer: CustomizerState;
  collapseSidebar: typeof collapseSidebar;
  changeMode: typeof changeMode;
  changeNavbarColor: typeof changeNavbarColor;
  changeNavbarType: typeof changeNavbarType;
  changeFooterType: typeof changeFooterType;
  changeMenuColor: typeof changeMenuColor;
  hideScrollToTop: typeof hideScrollToTop;
}

interface IState {
  width: number;
  sidebarState: boolean;
  layout: ThemeStyle;
  collapsedContent: boolean;
  sidebarHidden: boolean;
  customizer: boolean;
}

class VerticalLayout extends PureComponent<IProps, IState> {
  state: IState = {
    width: window.innerWidth,
    sidebarState: this.props.customizer.sidebarCollapsed,
    layout: this.props.customizer.theme,
    collapsedContent: this.props.customizer.sidebarCollapsed,
    sidebarHidden: false,
    customizer: false,
  };
  collapsedPaths: string[] = [];
  mounted = false;
  updateWidth = () => {
    if (this.mounted) {
      this.setState(() => ({
        width: window.innerWidth,
      }));
    }
  };

  handleCustomizer = (bool: boolean) => {
    this.setState({
      customizer: bool,
    });
  };

  componentDidMount() {
    this.mounted = true;
    let {
      location: { pathname },
      customizer: { theme, direction },
    } = this.props;

    if (this.mounted) {
      // @ts-ignore
      if (window !== 'undefined') {
        window.addEventListener('resize', this.updateWidth, false);
      }
      if (this.collapsedPaths.includes(pathname)) {
        this.props.collapseSidebar(true);
      }

      let layout = theme;
      let dir = direction;
      if (dir === 'rtl')
        document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
      else document.getElementsByTagName('html')[0].setAttribute('dir', 'ltr');
      return layout === 'dark'
        ? document.body.classList.add('dark-layout')
        : layout === 'semi-dark'
        ? document.body.classList.add('semi-dark-layout')
        : null;
    }
  }

  componentDidUpdate(prevProps: IProps) {
    let {
      location: { pathname },
      customizer: { theme, sidebarCollapsed },
    } = this.props;

    let layout = theme;
    if (this.mounted) {
      if (layout === 'dark') {
        document.body.classList.remove('semi-dark-layout');
        document.body.classList.add('dark-layout');
      }
      if (layout === 'semi-dark') {
        document.body.classList.remove('dark-layout');
        document.body.classList.add('semi-dark-layout');
      }
      if (layout !== 'dark' && layout !== 'semi-dark') {
        document.body.classList.remove('dark-layout', 'semi-dark-layout');
      }

      if (
        prevProps.customizer.sidebarCollapsed !==
        this.props.customizer.sidebarCollapsed
      ) {
        this.setState({
          collapsedContent: sidebarCollapsed,
          sidebarState: sidebarCollapsed,
        });
      }
      if (
        prevProps.customizer.sidebarCollapsed ===
          this.props.customizer.sidebarCollapsed &&
        pathname !== prevProps.location.pathname &&
        this.collapsedPaths.includes(pathname)
      ) {
        this.props.collapseSidebar(true);
      }
      if (
        prevProps.customizer.sidebarCollapsed ===
          this.props.customizer.sidebarCollapsed &&
        pathname !== prevProps.location.pathname &&
        !this.collapsedPaths.includes(pathname)
      ) {
        this.props.collapseSidebar(false);
      }
    }
  }

  handleCollapsedMenuPaths = (item: string) => {
    let collapsedPaths = this.collapsedPaths;
    if (!collapsedPaths.includes(item)) {
      collapsedPaths.push(item);
      this.collapsedPaths = collapsedPaths;
    }
  };

  toggleSidebarMenu = () => {
    this.setState({
      sidebarState: !this.state.sidebarState,
      collapsedContent: !this.state.collapsedContent,
    });
  };

  sidebarMenuHover = (val: boolean) => {
    this.setState({
      sidebarState: val,
    });
  };

  handleSidebarVisibility = () => {
    if (this.mounted) {
      if (window !== undefined) {
        window.addEventListener('resize', () => {
          if (this.state.sidebarHidden) {
            this.setState({
              sidebarHidden: !this.state.sidebarHidden,
            });
          }
        });
      }
      this.setState({
        sidebarHidden: !this.state.sidebarHidden,
      });
    }
  };

  componentWillUnmount() {
    this.mounted = false;
  }

  render() {
    let appProps = this.props.customizer;
    let sidebarProps = {
      activePath: this.props.match.path,
      activeTheme: appProps.menuTheme,
      collapsed: this.state.collapsedContent,
      collapsedMenuPaths: this.handleCollapsedMenuPaths,
      deviceWidth: this.state.width,
      sidebarState: this.state.sidebarState,
      sidebarHover: this.sidebarMenuHover,
      sidebarVisibility: this.handleSidebarVisibility,
      toggle: this.toggleSidebarMenu,
      toggleSidebarMenu: this.props.collapseSidebar,
      visibilityState: this.state.sidebarHidden,
    };
    let navbarProps = {
      navbarColor: appProps.navbarColor,
      navbarType: appProps.navbarType,
      sidebarVisibility: this.handleSidebarVisibility,
    };

    let footerProps = {
      footerType: appProps.footerType,
      hideScrollToTop: appProps.hideScrollToTop,
    };

    let customizerProps = {
      customizerState: this.state.customizer,
      handleCustomizer: this.handleCustomizer,
      changeMode: this.props.changeMode,
      changeNavbar: this.props.changeNavbarColor,
      changeNavbarType: this.props.changeNavbarType,
      changeFooterType: this.props.changeFooterType,
      changeMenuTheme: this.props.changeMenuColor,
      collapseSidebar: this.props.collapseSidebar,
      hideScrollToTop: this.props.hideScrollToTop,
      activeMode: appProps.theme,
      activeNavbar: appProps.navbarColor,
      navbarType: appProps.navbarType,
      footerType: appProps.footerType,
      menuTheme: appProps.menuTheme,
      scrollToTop: appProps.hideScrollToTop,
      sidebarState: appProps.sidebarCollapsed,
    };
    return (
      <div
        className={classnames(
          `wrapper vertical-layout theme-${appProps.menuTheme}`,
          {
            'menu-collapsed':
              this.state.collapsedContent === true && this.state.width >= 1200,
            'fixed-footer': appProps.footerType === 'sticky',
            'navbar-static': appProps.navbarType === 'static',
            'navbar-sticky': appProps.navbarType === 'sticky',
            'navbar-floating': appProps.navbarType === 'floating',
            'navbar-hidden': appProps.navbarType === 'hidden',
          }
        )}
      >
        <Sidebar {...sidebarProps} />
        <div className="app-content content">
          <Navbar {...navbarProps} />
          <div className="content-wrapper">{this.props.children}</div>
        </div>

        <Footer {...footerProps} />
        {appProps.disableCustomizer !== true ? (
          <Customizer {...customizerProps} />
        ) : null}
        <div
          className="sidenav-overlay"
          onClick={this.handleSidebarVisibility}
        />
        <ComboKeys />
      </div>
    );
  }
}

const mapStateToProps = ({ customizer }: RootState) => ({ customizer });

export default connect(mapStateToProps, {
  changeMode,
  collapseSidebar,
  changeNavbarColor,
  changeNavbarType,
  changeFooterType,
  changeMenuColor,
  hideScrollToTop,
})(VerticalLayout);
